/* Shipping calendar — the one source for every date the shop promises in the
   browser: the promise band of the home page (mbb-start.js, Versprechen) and the
   delivery line of the product page (mbb-produkt.js). Until 04.11.2026 both files
   carried their own copy of these lines (A-616).

   Rules: cut-off Mon–Fri 14:00 and Sat 11:00 Berlin time; no shipping on Sundays,
   on the public holidays of Baden-Württemberg and on 31.12. (the warehouse does not
   ship that day). Whether Saturday counts as a delivery day is the caller's
   argument: only DHL in Germany delivers then, UPS Standard abroad does not.

   A day is the UTC timestamp of the Berlin calendar day, so adding a day never
   meets a DST change.

   Loaded with defer next to the script that uses it. The order of the tags does
   not matter: a deferred script runs before DOMContentLoaded, but mbb-start.js
   starts its modules as soon as it runs, possibly before this file — callers wait
   for the event „mbb:versandkalender“ when the object is not there yet.

   Server-side counterparts stay in Liquid: transit days and shipping costs in
   snippets/versandfakten.liquid, the cut-off for the structured data in
   snippets/head-schema.liquid (cutoffTime). */
(() => {
  if (window.mbbVersandkalender) return;

  const TAG = 864e5;
  const feiertagsJahre = new Map();
  function ostersonntag(j) {
    const a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const n = h + l - 7 * m + 114;
    return Date.UTC(j, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  function feiertage(j) {
    if (!feiertagsJahre.has(j)) {
      const o = ostersonntag(j);
      // Baden-Württemberg plus 31.12.
      const fest = [[0, 1], [0, 6], [4, 1], [9, 3], [10, 1], [11, 25], [11, 26], [11, 31]].map(([m, t]) => Date.UTC(j, m, t));
      // Good Friday, Easter Monday, Ascension, Whit Monday, Corpus Christi.
      const beweglich = [-2, 1, 39, 50, 60].map((n) => o + n * TAG);
      feiertagsJahre.set(j, new Set([...fest, ...beweglich]));
    }
    return feiertagsJahre.get(j);
  }
  const istArbeitstag = (t) => new Date(t).getUTCDay() !== 0 && !feiertage(new Date(t).getUTCFullYear()).has(t);
  const schlussStunde = (t) => (new Date(t).getUTCDay() === 6 ? 11 : 14);
  function berlinJetzt() {
    const z = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .forEach((p) => (z[p.type] = Number(p.value)));
    return { tag: Date.UTC(z.year, z.month - 1, z.day), minute: z.hour * 60 + z.minute };
  }
  /** Day on which an order placed now leaves the warehouse. */
  function versandtagFuer(jetzt) {
    let t = jetzt.tag;
    if (istArbeitstag(t) && jetzt.minute < schlussStunde(t) * 60) return t;
    for (let i = 0; i < 60; i++) {
      t += TAG;
      if (istArbeitstag(t)) return t;
    }
    return null;
  }
  /** Day t plus n working days; Saturday counts only with samstag. */
  function plusArbeitstage(t, n, samstag) {
    let r = t;
    for (let i = 0; n > 0 && i < 120; i++) {
      r += TAG;
      if (istArbeitstag(r) && (samstag || new Date(r).getUTCDay() !== 6)) n--;
    }
    return r;
  }

  window.mbbVersandkalender = { TAG, istArbeitstag, schlussStunde, berlinJetzt, versandtagFuer, plusArbeitstage };
  document.dispatchEvent(new Event('mbb:versandkalender'));
})();
